import type { ADNode } from '@atlaskit/editor-common/utils/validator';
import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const MoveBlogModalLoader: LoadableType<
	Omit<
		{
			onMoveSuccess?: () => void;
			onMoveFail?: () => void;
			onClose: () => void;
			currentSpaceKey: string;
			blogPostId: string;
			isEditMode?: boolean;
			isUnpublishedDraft: boolean | null | undefined;
			flags: FlagsStateContainer;
			retrieveEditorTitleAndContent?: () => Promise<{
				title?: string | null | undefined;
				adf: ADNode;
				syncRev?: string;
				ncsStepVersion?: string;
			}>;
			referrer?: string;
			onContinue?: (arg: { newSpaceKey: string }) => void;
			newSpaceKey?: string;
		} & DialogsContainerProps,
		'flags'
	>
> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-MoveBlogModal" */ './MoveBlogModal.tsx'))
			.MoveBlogModal,
});
